// extracted by mini-css-extract-plugin
export default {"container":"description_container__edfQm","title":"description_title__pPt3q","showMore":"description_showMore__bwrMT","descriptionDetailed":"description_descriptionDetailed__BYEv0"};